import { IDmLoaiLopTinChi } from "../../model/respone/category/IDmLoaiLopTinChi";
import { apiClient } from "../apiClient";

export const LOAI_LOP_TIN_CHI_ENDPOINT = "loai-lop-tin-chi";

export const dmLoaiLopTinChiApi = {
  SelectAll: () => apiClient.get(`${LOAI_LOP_TIN_CHI_ENDPOINT}`),
  Insert: (payload: IDmLoaiLopTinChi) =>
    apiClient.post(`${LOAI_LOP_TIN_CHI_ENDPOINT}`, payload),
  Update: (payload: IDmLoaiLopTinChi) =>
    apiClient.put(`${LOAI_LOP_TIN_CHI_ENDPOINT}`, payload),
  Delete: (loai_lop: number) =>
    apiClient.delete(`${LOAI_LOP_TIN_CHI_ENDPOINT}/${loai_lop}`),
};

